import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  InputsDiv,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import settingPwImage from "../../styles/images/img_lock.png";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import { Modal } from "../../components/modal/Modal";

const SettingPassword = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [checkedPw, setCheckedPw] = useState(false);
  const [checkedConfirmPw, setCheckedConfirmPw] = useState(false);
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const eulaData = useSelector((state) => state.auth.signUpInfo_eulas);
  const signUpInfoData = useSelector((state) => state.auth.signUpInfo);
  const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);
  const modalMsg = useSelector((state) => state.auth.modalMsg);
  useEffect(() => {
    const passwordRegex =
      /^(?=.*[~!@#$%^&*()?])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[~!@#$%^&*()?a-zA-Z0-9]{8,20}$/;
    if (passwordRegex.test(passwords.password)) {
      setCheckedPw(true);
    } else {
      setCheckedPw(false);
    }

    if (
      passwords.password &&
      passwords.password === passwords.confirmPassword
    ) {
      setCheckedConfirmPw(true);
    } else {
      setCheckedConfirmPw(false);
    }
  }, [passwords]);

  const handleSignUp = () => {
    const params = {
      email: signUpInfoData.email, // (required) 이메일, 포맷체크
      password: passwords.password, // (required) 대문자+소문자+특수기호+숫자조합
      confirmPassword: passwords.confirmPassword, // (required) 비밀번호확인
      phone: signUpInfoData.phone, // (required) phone
      name: signUpInfoData.name, // (optional) name
      birth: signUpInfoData.birth, // (optional) birth, format check
      tid: signUpInfoData.tid, // (required) portone imp_uid 값
      gender: signUpInfoData.gender,
      eulaAge: eulaData.eulaAge,
      eulaTerms: eulaData.eulaTerms,
      eulaPrivacy: eulaData.eulaPrivacy,
      eula3rd: eulaData.eula3rd,
      eulaMarketing: eulaData.eulaMarketing,
    };

    dispatch(authActions.fetchSignUp({ params }));
  };

  useDidMountEffect(() => {
    if (signUpSuccess) navigate("/sign-up/result", { replace: true });
  }, [signUpSuccess]);
  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <OnePageLayout title="비밀번호 등록">
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      <Section>
        <Content>
          <InputsDiv>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 입력하세요."
                name="password"
                value={passwords.password}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                <p>
                  8~20자 영문 대소문자, 숫자, 특수문자 혼합,
                  <br /> 대소문자 구별 (예시 : Abc123!@#)
                  <br /> *사용가능 특수문자 : ~, !, @, #, $, %, ^, &, *, ?,
                  &#40;, &#41;
                </p>
                {!checkedPw && passwords.password != "" && (
                  <p className="pink">사용할 수 없는 비밀번호입니다.</p>
                )}
                {checkedPw && (
                  <p className="col">사용 가능한 비밀번호입니다.</p>
                )}
              </SettingPwInfo>
            </div>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 한번 더 입력 부탁드립니다."
                name="confirmPassword"
                value={passwords.confirmPassword}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                {checkedConfirmPw && (
                  <p className="col">비밀번호가 일치합니다.</p>
                )}
              </SettingPwInfo>
            </div>
          </InputsDiv>
          <SettingPwImg>
            <img src={settingPwImage} alt="" />
          </SettingPwImg>
        </Content>
        <Btns>
          <ButtonL
            disabled={!(checkedPw && checkedConfirmPw)}
            onClick={() => {
              handleSignUp();
            }}
          >
            다음
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default SettingPassword;

const SettingPwInfo = styled(TextDiv)`
  text-align: left;
  p {
    margin-top: 1rem;
  }
`;
const SettingPwImg = styled(ImgWrap)`
  margin-top: 5.5rem;
  img {
    width: 17.7rem;
  }
`;
